/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LedgerStandingRow } from './LedgerStandingRow';
import {
    LedgerStandingRowFromJSON,
    LedgerStandingRowFromJSONTyped,
    LedgerStandingRowToJSON,
    LedgerStandingRowToJSONTyped,
} from './LedgerStandingRow';
import type { LeaderboardPeriodType } from './LeaderboardPeriodType';
import {
    LeaderboardPeriodTypeFromJSON,
    LeaderboardPeriodTypeFromJSONTyped,
    LeaderboardPeriodTypeToJSON,
    LeaderboardPeriodTypeToJSONTyped,
} from './LeaderboardPeriodType';

/**
 * 
 * @export
 * @interface GetLedgerStandingsResponse
 */
export interface GetLedgerStandingsResponse {
    /**
     * 
     * @type {Array<LedgerStandingRow>}
     * @memberof GetLedgerStandingsResponse
     */
    standings: Array<LedgerStandingRow>;
    /**
     * 
     * @type {string}
     * @memberof GetLedgerStandingsResponse
     */
    periodKey: string;
    /**
     * 
     * @type {number}
     * @memberof GetLedgerStandingsResponse
     */
    total: number;
    /**
     * The board's word for a member — its column header. Absent renders "Player".
     * @type {string}
     * @memberof GetLedgerStandingsResponse
     */
    memberNoun?: string;
    /**
     * The board's word for what it pays — the reward tab and that view's heading. Absent renders "Rewards".
     * @type {string}
     * @memberof GetLedgerStandingsResponse
     */
    rewardsNoun?: string;
    /**
     * The authenticated requester's rank on this board, when they hold a standing.
     * @type {number}
     * @memberof GetLedgerStandingsResponse
     */
    myRank?: number;
    /**
     * The authenticated requester's points on this board, 0 when they have not scored on this period. Present for any authenticated requester, so own-position widgets work for users outside the returned page AND for a member who has yet to score — myRank is absent in that case, because they hold no rank.
     * @type {number}
     * @memberof GetLedgerStandingsResponse
     */
    myPoints?: number;
    /**
     * 
     * @type {LeaderboardPeriodType}
     * @memberof GetLedgerStandingsResponse
     */
    periodType: LeaderboardPeriodType;
    /**
     * The board's own display config — when true, clients offer the all-time view (periodKey "") beside the current period.
     * @type {boolean}
     * @memberof GetLedgerStandingsResponse
     */
    showAllTime?: boolean;
    /**
     * Epoch ms when the CURRENT period closes. Present only when serving the server-resolved current period — closed periods are final and the all-time row never closes.
     * @type {number}
     * @memberof GetLedgerStandingsResponse
     */
    periodEndsAt?: number;
}



/**
 * Check if a given object implements the GetLedgerStandingsResponse interface.
 */
export function instanceOfGetLedgerStandingsResponse(value: object): value is GetLedgerStandingsResponse {
    if (!('standings' in value) || value['standings'] === undefined) return false;
    if (!('periodKey' in value) || value['periodKey'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('periodType' in value) || value['periodType'] === undefined) return false;
    return true;
}

export function GetLedgerStandingsResponseFromJSON(json: any): GetLedgerStandingsResponse {
    return GetLedgerStandingsResponseFromJSONTyped(json, false);
}

export function GetLedgerStandingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLedgerStandingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'standings': ((json['standings'] as Array<any>).map(LedgerStandingRowFromJSON)),
        'periodKey': json['periodKey'],
        'total': json['total'],
        'memberNoun': json['memberNoun'] == null ? undefined : json['memberNoun'],
        'rewardsNoun': json['rewardsNoun'] == null ? undefined : json['rewardsNoun'],
        'myRank': json['myRank'] == null ? undefined : json['myRank'],
        'myPoints': json['myPoints'] == null ? undefined : json['myPoints'],
        'periodType': LeaderboardPeriodTypeFromJSON(json['periodType']),
        'showAllTime': json['showAllTime'] == null ? undefined : json['showAllTime'],
        'periodEndsAt': json['periodEndsAt'] == null ? undefined : json['periodEndsAt'],
    };
}

export function GetLedgerStandingsResponseToJSON(json: any): GetLedgerStandingsResponse {
    return GetLedgerStandingsResponseToJSONTyped(json, false);
}

export function GetLedgerStandingsResponseToJSONTyped(value?: GetLedgerStandingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'standings': ((value['standings'] as Array<any>).map(LedgerStandingRowToJSON)),
        'periodKey': value['periodKey'],
        'total': value['total'],
        'memberNoun': value['memberNoun'],
        'rewardsNoun': value['rewardsNoun'],
        'myRank': value['myRank'],
        'myPoints': value['myPoints'],
        'periodType': LeaderboardPeriodTypeToJSON(value['periodType']),
        'showAllTime': value['showAllTime'],
        'periodEndsAt': value['periodEndsAt'],
    };
}

